export default __webpack_public_path__ + "static/media/dolor por la patria.ca54253f.jpg";